// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--1iQtF";